import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div dir="rtl" className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ink p-8 text-center">
          <div className="font-display text-4xl font-bold text-gold">MERO</div>
          <p className="text-zinc-300">حدث خطأ غير متوقع في هذه الصفحة.</p>
          <button onClick={() => window.location.href = "/"} className="btn-gold">العودة للرئيسية</button>
        </div>
      );
    }
    return this.props.children;
  }
}
